<template >
  	<div class="login_box"  >
      <h2 class="run_title">登录</h2>
	  	<div class="centerCon" >
       		<div class="login-img">
				<img src="../../assets/login/login_bg.png"/>
			</div>
      		<div class="content">
			    <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" class="login_form_box login_form_box_v2">
					<div class="loginCon" >
						<img src="../../assets/login/login_logo.png">
					</div>
					<el-form-item prop="account">
						<el-input type="text" v-model="ruleForm2.account" autocomplete="off" placeholder="请输入手机号"></el-input>
					</el-form-item>
					<el-form-item prop="checkPass">
						<el-input type="password" v-model="ruleForm2.checkPass" autocomplete="off" placeholder="请输入密码"></el-input>
					</el-form-item>
					<!-- <el-form-item label="验证">
						<div class="form-inline-input">
							<div class="code-box" id="code-box" style="width:98%" >
							<input type="text" name="code" class="code-input" />
							<p></p>
							<span :class="verification==true?'greenV':'redV' " >
								<i class="el-icon-right" v-if="!verification" ></i>
								<i class="el-icon-check" v-else="verification" ></i>
							</span>
							</div>
						</div>
					</el-form-item> -->
			  		<el-form-item style="width:100%;">
			  	    	<el-button type="FF7" style="width:100%;" @click.native.prevent="handleSubmit2" :loading="logining">登录</el-button>
			  	  	</el-form-item>

			  	  	<el-form-item>
			  			<router-link class="link_btn fl" to="/forget">忘记密码</router-link>
			  	    	<router-link class="link_btn fr" to="/regs">用户注册</router-link>
			  	  	</el-form-item>

			  	</el-form>
      		</div>
		</div>
		<div class="login-footer" v-html="copyRight">
		</div>
  </div>

</template>

<script>

import routes from '@/routes'
import {requestLogin, getUserList} from '../../api/api';
// import identify from '@/components/account/identify.vue';
import md5 from 'md5';
//import NProgress from 'nprogress'
export default {
//     components:{
//         identify,
// 	},
  data() {
    return {
      checked2: false,
      copyRight: '',
      verification: false,
      clientWidth: "",
      contentWidth: 310,
      logining: false,
      ruleForm2: {
        account: '',
        checkPass: '',
        // identify_code:''
      },
      rules2: {
        account: [
          {required: true, message: '请输入账号', trigger: 'blur'},
        ],
        checkPass: [
          {required: true, message: '请输入密码', trigger: 'blur'},
        ],
      },
      checked: true
    };
  },

  created() {
    let that = this;this.getcopyRight();
    document.onkeypress = function (e) {
      var keycode = document.all ? event.keyCode : e.which;
      if (keycode == 13) {
        that.handleSubmit2();// 登录方法名
        return false;
      }
    }
  },

  mounted() {

    // var _this = this;
    // var code = "jsaidaisd656",
    // codeFn = new _this.moveCode(code,_this);
    if (localStorage.getItem("acc")) {
      this.ruleForm2.account = localStorage.getItem("acc")
      this.ruleForm2.checkPass = localStorage.getItem("passW")
      this.verification = true
      this.handleSubmit2();
    }

    localStorage.setItem("acc", this.ruleForm2.account)
    localStorage.setItem("passW", this.ruleForm2.checkPass)

  },
  methods: {
    getDefaultUrl(roleList) {
      var default_url = '';
      for (let i = 0; i < routes.length; i++) {
        if (roleList.indexOf(routes[i].id) !== -1) {
          default_url = routes[i].path;
          break;
        }
      }
      return default_url;
    },
    getcopyRight() {
      this.$ajax({
        'method': 'com.get.basic.common.init.init',
      }).then(res => {
        if (res.status === 10000) {
          this.copyRight = res.data.copyright
        } else {
          this.$message.error(res.info);
        }
        this.loading = false;
      })
    },
    handleSubmit2(ev) {
      var vue = this;
      this.$refs.ruleForm2.validate((valid) => {
        if (valid) {
          //    if (this.verification==false) {
          // 	 this.$message("请滑动解锁","error");
          // 	 return;
          //   }
          this.logining = true;
          var loginParams = {
            'method': 'com.set.merchant_user.auth.login',
            'data': {
              'merchant_account': this.ruleForm2.account,
              'merchant_password': md5(this.ruleForm2.checkPass),
              'source': '2'
            }
          };
          this.$ajax(loginParams).then(res => {

            if (res.status == 10000) {

              if (res.data.type == '1' || res.data.type == '2') {
                if (res.data.type === '1') {
                  localStorage.setItem('tokenInfo', JSON.stringify(res.data.data));
                  var url = this.getDefaultUrl(res.data.data.merchant_role);
                  if (url) {
                    this.$router.push({path: url});
                  } else {
                    this.$router.push({path: '/main'});
                  }
                } else {
                  window.open(res.data.data);
                }

              } else {
                localStorage.setItem('tokenInfo', JSON.stringify(res.data));
                vue.$router.push({path: '/select'});
              }
            } else {


              this.$message.error(res.info);
            }
            this.logining = false;
          });
          // 存储账号
          if (this.checked2 == true) {
            localStorage.setItem("acc", this.ruleForm2.account)
            localStorage.setItem("passW", this.ruleForm2.checkPass)
          }


        } else {
          return false;
        }
      });
    },
    //滑动
    getOffset(box, direction) {
      var setDirection = (direction == 'top') ? 'offsetTop' : 'offsetLeft';
      var offset = box[setDirection];
      var parentBox = box.offsetParent;
      while (parentBox) {
        offset += parentBox[setDirection];
        parentBox = parentBox.offsetParent;
      }
      parentBox = null;
      return parseInt(offset);
    },
    moveCode(code, _this) {
      var fn = {codeVluae: code};
      var box = document.querySelector("#code-box"),
          progress = box.querySelector("p"),
          codeInput = box.querySelector('.code-input'),
          evenBox = box.querySelector("span");
      //默认事件
      var boxEven = [];
      //改变手机端与pc事件类型
      var ww = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth || window.screen.width;
      if (ww <= 1080 || ww <= "1080px") {
        boxEven = ['touchstart', 'touchmove', 'touchend'];
      } else {
        boxEven = ['mousedown', 'mousemove', 'mouseup'];
      }
      var goX, offsetLeft, deviation, evenWidth, endX;

      function moveFn(e) {
        e.preventDefault();
        e = (boxEven['0'] == 'touchstart') ? e.touches[0] : e || window.event;
        endX = e.clientX - goX;
        endX = (endX > 0) ? (endX > evenWidth) ? evenWidth : endX : 0;
        if (endX > evenWidth * 0.7) {
          progress.innerText = '松开验证';
          progress.style.backgroundColor = "#66CC66";
        } else {
          progress.innerText = '';
          progress.style.backgroundColor = "#FFFF99";
        }
        progress.style.width = endX + deviation + 'px';
        evenBox.style.left = endX + 'px';
      }

      function removeFn() {
        document.removeEventListener(boxEven['2'], removeFn, false);
        document.removeEventListener(boxEven['1'], moveFn, false);
        if (endX > evenWidth * 0.7) {
          progress.innerText = '验证成功';
          progress.style.width = evenWidth + deviation + 'px';
          evenBox.style.left = evenWidth + 'px'
          codeInput.value = fn.codeVluae;
          evenBox.onmousedown = null;
          _this.verification = true;
        } else {
          progress.style.width = '0px';
          evenBox.style.left = '0px';
        }
      };

      function getOffset(box, direction) {
        var setDirection = (direction == 'top') ? 'offsetTop' : 'offsetLeft';
        var offset = box[setDirection];
        var parentBox = box.offsetParent;
        while (parentBox) {
          offset += parentBox[setDirection];
          parentBox = parentBox.offsetParent;
        }
        parentBox = null;
        return parseInt(offset);
      };
      evenBox.addEventListener(boxEven['0'], function (e) {
        e = (boxEven['0'] == 'touchstart') ? e.touches[0] : e || window.event;
        goX = e.clientX,
            offsetLeft = getOffset(box, 'left'),
            deviation = this.clientWidth,
            evenWidth = box.clientWidth - deviation,
            endX;
        document.addEventListener(boxEven['1'], moveFn, false);
        document.addEventListener(boxEven['2'], removeFn, false);
      }, false);
      fn.setCode = function (code) {
        if (code)
          fn.codeVluae = code;
      }
      fn.getCode = function () {
        return fn.codeVluae;
      }
      fn.resetCode = function () {
        evenBox.removeAttribute('style');
        progress.removeAttribute('style');
        codeInput.value = '';
      };
      return fn;
    },
    //滑动结束
  }
}
</script>

<style scoped>
@import "../../styles/login.css";
</style>



// WEBPACK FOOTER //
// login.vue?6caa29f0